import React from 'react';
import { colorBrand } from '@devforce/tds-tokens';
import calculateImageDominantColor from './calculateImageDominantColor.js';
import getDisplayName from './getDisplayName.js';

function withAutomaticColorCalculation(WrappedComponent) {
  class WithAutomaticColorCalculation extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        calculatedColor: null
      };
      this.initialColor = props.content.color;
    }
    componentDidMount() {
      const {
        content: {
          image,
          color
        }
      } = this.props;
      if (!color && image) {
        this.calculateAccentColor(image);
      }
    }
    componentDidUpdate(prevProps) {
      const {
        content: {
          image
        }
      } = this.props;

      // If initially a color wasn't supplied, then we should recalculate
      // the color every time the image prop is calculated.
      if (image && !this.initialColor && image !== prevProps.content.image) {
        this.calculateAccentColor(image);
      }
    }
    calculateAccentColor(image) {
      calculateImageDominantColor(image).then(hexCode => {
        this.setState({
          calculatedColor: `#${hexCode}`
        });
      }).catch(() => {
        this.setState({
          calculatedColor: `${colorBrand}`
        });
      });
    }
    render() {
      const {
        content,
        ...passThroughProps
      } = this.props;
      const {
        calculatedColor
      } = this.state;
      return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
        content: {
          ...content,
          color: this.initialColor || calculatedColor
        }
      }, passThroughProps));
    }
  }
  WithAutomaticColorCalculation.displayName = "WithAutomaticColorCalculation";
  // See: https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
  WithAutomaticColorCalculation.displayName = `WithAutomaticColorCalculation(${getDisplayName(WrappedComponent)})`;
  return WithAutomaticColorCalculation;
}

export { withAutomaticColorCalculation as default };
